export default "__VITE_ASSET__DTWD92Jy__"